<app-layout>
  <div class="home">
    <img [src]="brand.logoHome" class="logotipo" alt="Logo" />
  </div>
</app-layout>
